<div
    class="d-flex justify-content-center align-items-center h-100"
    *ngIf="showLoadingSpinner"
>
    <div class="tryb-design-spinner"></div>
</div>
